(function() {

  function AssignmentTitleFilterFactory(
    scoreRangeFilter,
    assignedFocusApi,
    regmarkService,
    customer) {
    return function(assignment) {
      if (assignment.focusData && customer.isAstUk()) {
        return assignment.focusData.short_desc;
      }
      if (assignedFocusApi.isNweaAssignment(assignment)) {
        // In the current NWEA mapping files, the Domain is stored as a Level and the RIT score range is stored as a
        // Concept/Domain.
        if(assignedFocusApi.isLegacyNwea(assignment)) {
          return assignment.focusData.level + ' (' + scoreRangeFilter(assignment.focusData.concept) + ')';
        }

        //loc nwea
        return assignment.focusData.concept + ' (' + scoreRangeFilter(assignment.focusData.cluster) + ')';
      } else if (assignedFocusApi.isQuantileAssignment(assignment)) {
        return assignment.focusData.level.replace('Quantile', 'Quantile' + regmarkService.toString());
      } else if (assignment.focus_concept) {
        return assignment.focus_concept;
      } else if (assignment.name) {
        return assignment.name;
      }
    };
  }

  /**
   * This filter displays an assignment title given an assignment.
   */
  angular.module('edxComponents')
    .filter('edxAssignmentTitle', [
      'edxNweaScoreRangeFilter',
      'assignedFocusApi',
      'regmarkService',
      'customer',
      AssignmentTitleFilterFactory
    ]);

  /**
   * This filter displays a translated assignment title with fallback to original title.
   */
  function AssignmentTitleTranslateFilterFactory($filter) {
    var assignmentTitleFilter = $filter('edxAssignmentTitle');
    var translateFilter = $filter('translate');

    return function(assignment) {
      var title = assignmentTitleFilter(assignment);
      if (!title) {
        return '';
      }

      // Try to translate with curriculumData prefix
      var translationKey = 'curriculumData.' + title;
      var translated = translateFilter(translationKey, { defaultValue: title });

      return translated;
    };
  }

  angular.module('edxComponents')
    .filter('edxAssignmentTitleTranslate', ['$filter', AssignmentTitleTranslateFilterFactory]);

})();
